const initialState = {
    notifications: [],
    count: 0,
    next: null,
    previous: null
};

export const notificationsReducer = (state = initialState, action) => {

    switch (action.type) {
        case 'UPDATE_NOTIFICATIONS':
            return {
                ...state,
                notifications:
                    action.payload.notifications !== undefined
                        ? action.payload.notifications
                        : state.notifications,

                count:
                    action.payload.count !== undefined
                        ? action.payload.count
                        : state.count,

                next:
                    action.payload.next !== undefined
                        ? action.payload.next
                        : state.next,

                previous:
                    action.payload.previous !== undefined
                        ? action.payload.previous
                        : state.previous,
            };

        case 'UPDATE_UNREAD_NOTIFICATIONS':
            return {
                ...state,
                unread_notifications: action.payload.notifications,
                unread_count: action.payload.count

            };
        default:
            return state;
    }
};